export const SOS_HOME_URL = 'https://www.sos.eu/';
export const REDIRECT_TIME = 30000;
export const APPLICATION_NAME = 'onesos-supo';
